import styled from "styled-components";

import { COLORS } from "constants/colorScheme";

export const Container = styled.div`
  border-radius: 6px;
  padding: 6px 8px 7px 12px;
  background-color: ${COLORS.BACKGROUND};

  display: flex;
  align-items: center;

  margin-right: 12px;
  margin-top: 12px;
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  margin-right: 10px;

  min-height: 24px;
  min-width: 24px;

  background-image: url(${({ image }: { image: string }) => image});
  background-size: cover;
`;

export const ClearIconContainer = styled.span`
  display: flex;
  margin-left: 8px;

  cursor: pointer;
`;
